import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { CookiePolicyContentComponent } from './cookie-policy-content/cookie-policy-content.component';
import { RouterModule } from '@angular/router';
import { SharedUiModalModule } from '@portal/shared/ui/modal/src';

@NgModule({
  imports: [CommonModule, RouterModule, SharedUiModalModule],
  declarations: [FooterComponent, CookiePolicyContentComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
